import { render } from "./AccountListPage.vue?vue&type=template&id=1d89c8fe"
import script from "./AccountListPage.vue?vue&type=script&lang=js"
export * from "./AccountListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__